import axios from 'axios'

export function generateIdempotencyKey () {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  return `ck-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
}

export async function completeCheckout (payload) {
  const correlationId = sessionStorage.getItem('checkoutCorrelationId') || generateIdempotencyKey()
  sessionStorage.setItem('checkoutCorrelationId', correlationId)

  const response = await axios.post(
    `${process.env.VUE_APP_SERVER}/api/v2/checkout`,
    payload,
    {
      headers: {
        'X-Correlation-Id': correlationId
      }
    }
  )
  if (response.headers['x-correlation-id']) {
    sessionStorage.setItem('checkoutCorrelationId', response.headers['x-correlation-id'])
  }
  return response
}

export function shouldRotateIdempotencyKey (error) {
  const data = error?.response?.data || {}
  const code = data.code
  const checkoutStatus = data.checkoutStatus || data.status
  const httpStatus = error?.response?.status
  // Never create a new key for an in-progress or captured payment.
  if (
    code === 'IN_PROGRESS' ||
    code === 'CAPTURE_ORPHANED' ||
    checkoutStatus === 'capture_orphaned'
  ) {
    return false
  }
  // Retryable checkout failure.
  if (
    code === 'FAILED' ||
    checkoutStatus === 'failed'
  ) {
    return true
  }
  // Other server-side failures are retryable.
  return httpStatus >= 500 && httpStatus < 600
}
